// extracted by mini-css-extract-plugin
module.exports =  {"select":"H5ksQibpNDYIirHnBKfr"};